import { any, oneOf } from 'prop-types';
import { memo, useMemo } from 'react';
import styled from 'styled-components';
const StyledErrorMessage = styled.h5`
   color: #e41d32;
   display: inline-block;
   font-size: 14px;
   font-weight: 500;
   margin: 8px 0 0 0;
   &[data-size='large'] {
      font-size: 16px;
      margin: 10px 0 0 0;
   }
   &[data-size='small'] {
      font-size: 12px;
      margin: 5px 0 0 0;
   }
`;
const ErrorMessage = memo(({ message = '', size = 'small' }) => {
   const isViewErrorMessage = useMemo(() => {
      const isViewErrorMessage =
         (typeof message === 'string' || typeof message === 'number') &&
         message;
      return isViewErrorMessage;
   }, [message]);
   return (
      isViewErrorMessage && (
         <StyledErrorMessage data-size={size}>{message}</StyledErrorMessage>
      )
   );
});
ErrorMessage.propTypes = {
   message: any,
   size: oneOf(['large', 'medium', 'small']),
};
export default ErrorMessage;
